import React, { useState } from "react";

import {
  Box,
  Button,
  CircularProgress,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import {usePostGetSignedUrlMutation, usePostPayrollUploadMutation} from "../../redux/vmsApi";
import { uploadFileToS3 } from "../../../utils/mediaUtil";
import {
  usePostBomExternalItemMappingUploadMutation,
  usePostGetSignedUrlMutation,
} from "../../../redux/vmsApi";

const VisuallyHiddenInput = styled("input")({
  clipPath: "inset(50%)",
  height: 1,
  width: 1,
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  margin: 0,
});

const StyledPaper = styled(Paper)(({ theme }) => ({
  maxWidth: "100%",
  width: "100%",
  padding: theme.spacing(15),
  textAlign: "center",
  backgroundColor: theme.palette.background.default,
  boxShadow: theme.shadows[3],
  borderRadius: "5px",
}));

const UploadSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(),
  padding: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.default,
}));

const CreateExternalItemMapping: React.FC = () => {
  const [getSignedUrl] = usePostGetSignedUrlMutation();
  const [postBomExternalItemMappingUpload] =
    usePostBomExternalItemMappingUploadMutation();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | undefined>(undefined);

  const handleUploadAndGenerate = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setLoading(true);
      try {
        const uploadedFileUrl = await uploadFileToS3(
          file,
          getSignedUrl,
          () => {},
          false,
          "",
        );

        const response = await postBomExternalItemMappingUpload({
          body: {
            excelFile: uploadedFileUrl.url,
          },
        }).unwrap();

        setMessage(
          `Upload completed: ${response.inserted} inserted, ${response.skipped} skipped`,
        );
      } catch (error) {
        console.error("Upload error:", error);
        setMessage("Error occurred. Please try again.");
      } finally {
        setLoading(false);
        event.target.value = "";
      }
    }
  };

  return (
    <Box display="flex" justifyContent="center">
      <StyledPaper>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Import Items from an external source.
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ marginBottom: 4 }}
        >
          Supported file format: .xlsx
        </Typography>

        <UploadSection>
          <Button
            component="label"
            variant="contained"
            color="primary"
            startIcon={<CloudUploadIcon />}
            size="large"
            disabled={loading}
            fullWidth
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Import"
            )}
            <VisuallyHiddenInput
              type="file"
              accept=".xlsx"
              onChange={handleUploadAndGenerate}
            />
          </Button>
        </UploadSection>

        {message && (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ marginTop: 3 }}
          >
            {message}
          </Typography>
        )}
      </StyledPaper>
    </Box>
  );
};

export default CreateExternalItemMapping;
